export default "__VITE_ASSET__CVxhXPda__"